import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Search(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M10 4.5A5.507 5.507 0 004.5 10a1.5 1.5 0 003 0c0-1.379 1.121-2.5 2.5-2.5a1.5 1.5 0 000-3"
  }), React.createElement("path", {
    d: "M3 10c0-3.86 3.14-7 7-7s7 3.14 7 7a6.974 6.974 0 01-2.022 4.914c-.012.011-.027.014-.039.025-.011.012-.014.027-.025.039A6.974 6.974 0 0110 17c-3.86 0-7-3.14-7-7m20.561 11.439l-5.517-5.516A9.94 9.94 0 0020 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10a9.94 9.94 0 005.923-1.956l5.516 5.517c.293.293.677.439 1.061.439a1.502 1.502 0 001.061-2.561"
  }));
}

export { Search };
//# sourceMappingURL=Search.js.map